import classnames from 'classnames/bind'

// Components

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// PropTypes
type PropTypes = {
  className?: string
  icon: any
  isDisabled?: boolean
}

function ActionIcon(props: PropTypes) {
  const { className, icon: Icon, isDisabled } = props

  return (
    <div className={cx('actionIcon', className, { isDisabled })}>
      <div className={cx('actionIcon-icon', { isDisabled })}>
        <Icon />
      </div>
    </div>
  )
}

export default ActionIcon
